import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchBusinessById } from '../../actions/business'

const BusinessName = ({ businessId, isFetching, fetchBusinessById, business }) => {
  useEffect(() => {
    const asyncCall = async () => {
      if (!isFetching && ((businessId && !business) || businessId !== business.id)) {
        fetchBusinessById(businessId)
      }
    }
    asyncCall()
  }, [businessId, business, isFetching, fetchBusinessById])

  return (
    <>
      {business && business.name && (
        <div>
          <div className='ibox-title'>
            <h5>Business Name</h5>
          </div>
          <div className='ibox-content text-center text-uppercase'>
            <span className='bg-success p-xs' style={{ cursor: 'default' }}>
              {business && business.name}
            </span>
          </div>
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  isFetching: state.business.isFetching,
  business: state.business.business,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBusinessById,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(BusinessName)
